import React, { useState, useEffect } from 'react';
import { Grid, CircularProgress, Button } from '@mui/material';
import { useFormik } from 'formik';
import Page from '../components/Page';
import { useNavigate } from 'react-router-dom';
import { GoldMindsLogo } from 'src/images';
import { TextField } from 'src/components';
import {
  ResetPasswordBg1,
  ResetPasswordBg2,
  ResetPasswordBg3,
  ResetPasswordBg4,
} from 'src/images';
import { forgotPasswordValidationSchema } from 'src/validations/teacher';
import './styles/login.css';

// ----------------------------------------------------------------------

export default function ForgotPassword() {
  const navigate = useNavigate();
  // Randomly select a background image
  const [backgroundImage, setBackgroundImage] = useState('');
  const [loading, setLoading] = useState(false);

  const Continue = () => {
    navigate('/create-new-password');
  };

  useEffect(() => {
    const images = [
      ResetPasswordBg1,
      ResetPasswordBg2,
      ResetPasswordBg3,
      ResetPasswordBg4,
    ];
    const randomImage = images[Math.floor(Math.random() * images.length)];
    setBackgroundImage(randomImage);
  }, []);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: forgotPasswordValidationSchema,
    onSubmit: async (values) => {
      try {
         
        Continue();
        // Login(values, formik.resetForm);
      } catch (error) {
        console.error('Error creating student:', error);
      }
    },
  });

  return (
    <div className="_login_container">
      <Page title="Login">
        {/* <RootStyle> */}
        {/* <Container> */}
        <Grid container justifyContent="center">
          <Grid sm={12} xs={12} md={6} lg={6} xl={6}>
            <div className="loginFirstSec">
              <img src={GoldMindsLogo} width={120} height={120} />
              <h1>Reset Your Password</h1>
              <p className="loginDes">
                Enter the email address associated with your account and we'll send you a link to reset your password.
              </p>
              {/* <div style={{ marginTop: 20, marginBottom: 20 }}> */}
              <form onSubmit={formik.handleSubmit}>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                  <TextField
                    label="Email"
                    placeholder="Enter Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    name="email"
                    error={Boolean(formik.touched.email && formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                  <div className="forgotPwdSec">
                    <span className="forgotPasswordTxt" onClick={() => navigate('/login')}>
                      Return to login
                    </span>
                  </div>
                </div>
                <Button type="submit" fullWidth variant="contained" style={{ height: 55, marginTop: 20 }}>
                  {loading ? <CircularProgress color="inherit" size={20} /> : 'Continue'}
                </Button>
              </form>
              {/* <div className="_login_row">
                  <input
                    type={'email'}
                    placeholder="Enter Email"
                    value={email}
                    className="_auth_fields"
                    onChange={(e) => {
                      setEmail(e.target.value), setErr('');
                    }}
                  />
                </div> */}
              {/* <div className="forgotPwdSec">
                  <span className="forgotPasswordTxt" onClick={() => navigate('/login')}>
                    Return to login
                  </span>
                </div> */}
              {/* </div> */}
              {/* <button className="_btn" onClick={() => Continue()}>
                Continue
              </button> */}
            </div>
          </Grid>
          <Grid sm={12} xs={12} md={6} lg={6} xl={6}>
            <div className="loginSecondSec">
              <img src={backgroundImage} alt={'login Background'} className="loginBgImage" />
            </div>
          </Grid>
        </Grid>
      </Page>
    </div>
  );
}
